import React from 'react';
import './CaseStudyCard.scss';
import Arrow from '../../../Icons/Arrow';
import { COLORS } from '../../../../../constants/colors';
import { titleElement } from '../../util/titleElement';

/**
 * Renders content for a case-study type
 * @param {array} tags - tags associated with card/post
 * @param {string} title - the card title/quote
 * @param {string} link - the link for the card
 * @param {boolean} isFeatured
 * @param {string} backgroundColor
 * @param {boolean} isSearch
 * @returns {JSX.Element}
 * @constructor
 */
const CaseStudyCard = ({ company, title, link, isFeatured, backgroundColor, isSearch }) => (
  <div className={`c-case-study-card ${isFeatured ? 'is-featured' : ''}`}>
    <div className="c-case-study-card__company eyebrow-2">
      <span>{company}</span>
    </div>
    <div className="c-case-study-card__title h3-roobert">{titleElement('3', isSearch, title)}</div>
    <div className="c-case-study-card__cta eyebrow-1 color-black">
      <a href={link}>
        <span>Read Case Study</span>
        <Arrow
          color={
            isFeatured && backgroundColor === 'green'
              ? COLORS.white
              : isFeatured && (backgroundColor === 'orange' || backgroundColor === 'white')
              ? COLORS.black
              : COLORS.blue
          }
        />
      </a>
    </div>
  </div>
);

export default CaseStudyCard;
